import classNames from 'classnames';
import type { ComponentPropsWithRef, FC } from 'react';

import styles from './radio.module.scss';

export type RadioProps = Omit<ComponentPropsWithRef<'input'>, 'type'>;

export const Radio: FC<RadioProps> = ({ className, checked, ...props }) => (
  <span className={classNames(styles.wrapper, className)}>
    <input type="radio" checked={checked} {...props} className={classNames(styles.radio)} />
    <span className={classNames(styles.circle, checked && styles.checked)}></span>
  </span>
);
